module.exports = __webpack_public_path__ + "static/category-list-b6ec7a73f605320d66fa5dea328e96fa.png";